import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCopyCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.6668 5L7.50016 14.1667L3.3335 10",
		stroke: "#008500",
		strokeWidth: 1.25,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCopyCheck;
